import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React from 'react';
import Caption from '../Caption';
import styles from './index.module.css';
const ChoiceMessage = props => /*#__PURE__*/React.createElement(Caption, _extends({
  as: "span"
}, props, {
  className: styles.message
}));
export default ChoiceMessage;